import React from 'react';
import { Link } from 'react-router-dom';
import './PresenceOnboarding.css';

export default function Contact() {
  return (
    <div className="presence-onboarding">
      <div className="presence-onboarding__inner">
        <section className="presence-card">
          <div className="presence-card__title">Schedule a conversation</div>
          <div className="presence-card__copy">
            <p>
              Use Messenger to coordinate a live session, or return to the Presence Test Drive.
            </p>
          </div>
          <div className="presence-pricing-cta">
            <Link to="/messenger" className="presence-button">
              Open Messenger
            </Link>
            <Link to="/presence/onboarding" className="presence-button presence-button--ghost">
              Presence Test Drive
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
}
